<template>
  <section class="ren-decoration-cp ren-decoration-cp-scenic-home-gallery">
    <header class="ren-decoration-cp-scenic-home-gallery__head">
      <strong>{{ title }}</strong>
    </header>
    <div v-if="slides.length === 0" class="ren-decoration-cp-scenic-home-gallery__empty">暂无景区图片</div>
    <div v-else class="ren-decoration-cp-scenic-home-gallery__track">
      <img
        v-for="(slide, index) in slides"
        :key="`${slide.label}-${index}`"
        :src="slide.image"
        alt=""
        class="ren-decoration-cp-scenic-home-gallery__img" />
      <div
        v-for="(slide, index) in placeholders"
        :key="`ph-${index}`"
        class="ren-decoration-cp-scenic-home-gallery__img ren-decoration-cp-scenic-home-gallery__img--placeholder"
        :style="{ backgroundImage: `linear-gradient(135deg, ${slide.from}, ${slide.to})` }"
        aria-hidden="true">
        <i>{{ slide.label.slice(0, 1) }}</i>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() => stringValue(props.component.props?.title, '景区环境'))

interface SlideSource {
  label: string
  image: string
  from: string
  to: string
}

const SAMPLE_SLIDES: SlideSource[] = [
  { label: '云海日出', image: '', from: '#7FB5A4', to: '#4E9E82' },
  { label: '玻璃栈道', image: '', from: '#8FA8CC', to: '#5B7BA6' },
  { label: '山涧溪谷', image: '', from: '#D8B27A', to: '#B98A4E' },
  { label: '观景平台', image: '', from: '#A98FC0', to: '#7E63A1' }
]

const rawImages = computed(() => {
  const value = props.component.props?.imageUrls
  return Array.isArray(value) ? value.map((item) => widgetMediaUrl(item)).filter(Boolean) : []
})
const slides = computed(() => rawImages.value.map((image, index) => ({
  label: SAMPLE_SLIDES[index % SAMPLE_SLIDES.length].label,
  image
})))
const placeholders = computed(() => (slides.value.length ? [] : SAMPLE_SLIDES))
</script>

<style scoped>
.ren-decoration-cp-scenic-home-gallery {
  display: grid;
  gap: 8px;
  padding: 12px;
  background: var(--ren-theme-card);
}
.ren-decoration-cp-scenic-home-gallery__head strong {
  color: var(--ren-theme-text);
  font-size: 14px;
}
.ren-decoration-cp-scenic-home-gallery__empty {
  margin: 0;
  color: var(--ren-theme-muted);
  font-size: 12px;
}
.ren-decoration-cp-scenic-home-gallery__track {
  display: flex;
  gap: 8px;
  overflow-x: auto;
}
.ren-decoration-cp-scenic-home-gallery__img {
  flex: 0 0 auto;
  width: 120px;
  height: 90px;
  border-radius: var(--ren-theme-radius);
  object-fit: cover;
}
.ren-decoration-cp-scenic-home-gallery__img--placeholder {
  display: grid;
  place-items: center;
  color: #fff;
}
.ren-decoration-cp-scenic-home-gallery__img--placeholder i {
  font-style: normal;
  font-size: 20px;
  opacity: 0.92;
}
</style>
